import { render, staticRenderFns } from "./SaleAccounts.vue?vue&type=template&id=1ae8ad8a&scoped=true"
import script from "./SaleAccounts.vue?vue&type=script&lang=ts"
export * from "./SaleAccounts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae8ad8a",
  null
  
)

export default component.exports